import { Component, OnDestroy } from '@angular/core';
import { SharedServiceRegistry } from './../../../shared-service-registry';
import { CoreServiceRegistry } from './../../../../core/core-service-registry';
import { ResourceService } from 'sce-core';
import { SearchService } from './../../../search/search.service';
import { SearchParams } from './../../../search/models/search-params.model';
import { SearchStatus } from './../../../search/models/search-status.model';

@Component({
  selector: 'lfwms-view-transactions-popup',
  templateUrl: './view-transactions-popup.component.html',
  styleUrls: ['./view-transactions-popup.component.css']
})
export class ViewTransactionsPopupComponent implements OnDestroy {

  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  private srcTypeMapping: any = {
    'asntd': 'RECEIPT',
    'picktd': 'PickDetail',
    'trtd': 'RECEIPT',
    'ixdocktd': 'RECEIPT',
    'oxdocktd': 'RECEIPT',
    'adjtd': 'Adjustment',
    'uccadjtd': 'Adjustment',
    'transfertd': 'Transfer',
    'inventoryqctd': 'InventoryQCDetail',
    'jobdettd': 'WOJobInv',
    'kittd': 'Kit'
  };
  public isLoading: boolean = true;
  public searchService: SearchService;
  public resourceService: ResourceService;

  constructor(coreServiceRegistry: CoreServiceRegistry,
      private sharedServiceRegistry: SharedServiceRegistry) {
    this.resourceService = coreServiceRegistry.resourceService;
  }

  public initialize(datatableId: string, searchCriteria: any) {
    searchCriteria.conditions[0].clauses.push({
      column: 'sourceType',
      operation: 'contains',
      value: this.srcTypeMapping[datatableId],
      logicalOperation: 'AND'
    });
    this.searchParams = new SearchParams();
    this.searchParams.tableId = 'viewtransactiontd';
    this.searchParams.isFullFetch = true;
    this.searchStatus = new SearchStatus();
    this.searchService = this.sharedServiceRegistry
      .createSearchService(this.searchParams, this.searchStatus);
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.searchService.setSearchCriteria(searchCriteria);
        this.searchService.performSearch();
        this.isLoading = false;
      });
  }

  public ngOnDestroy() {
    // Memory Cleanup
    this.searchService = null;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/view-transactions-popup/view-transactions-popup.component.ts